




















































import {
  CampaignReportData,
  CampaignReportItem,
} from "@/models/CampaignReport";
import Campaign, { LineItem } from "@/models/campaign";
import { get, groupBy } from "lodash";
import moment from "moment";
import { Component, Vue, Prop } from "vue-property-decorator";

class DataEntry {
  lineItemId: string;
  adUnitId: string | undefined;
  definitions: string[] | undefined;
  environment: string | null;
  country: string | null;
  days: number;
  prints: number;
  clicks: number;

  constructor(params?: DataEntry) {
    this.lineItemId = get(params, "lineItemId", "");
    this.adUnitId = get(params, "adUnitId", "");
    this.definitions = get(params, "definitions", []);
    this.environment = get(params, "environment", "");
    this.country = get(params, "country", "");
    this.days = get(params, "days", 0);
    this.prints = get(params, "prints", 0);
    this.clicks = get(params, "clicks", 0);
  }
}

@Component
export default class ClientCampaignReportDetailTable extends Vue {
  @Prop() inputData!: CampaignReportData;
  @Prop() lineItems!: string[];
  @Prop({ default: "by_position" }) groupType!: string;
  @Prop({ default: "" }) sectionTitle!: string;

  headers: { text: string; sortable: boolean; value: string }[] = [];
  data: { lineItemId: string; prints: number; clicks: number }[] = [];
  created(): void {
    this.buildHeaders();

    switch (this.groupType) {
      case "by_position":
        this.prepareDataByAdUnit();
        break;
      case "by_environment":
        this.prepareDataByEnvironment();
        break;
    }
  }

  prepareDataByAdUnit(): void {
    const data = this.prepareData();

    const groupedData = groupBy(data, (i) => {
      return i.adUnitId;
    });

    Object.keys(groupedData).forEach((d) => {
      const entry = new DataEntry();
      entry.adUnitId = d;
      entry.days = moment(this.inputData.meta.report.end).diff(
        this.inputData.meta.report.start,
        "days"
      );

      groupedData[d].forEach((i) => {
        entry.clicks += i.clicks;
        entry.prints += i.prints;
      });

      entry.clicks > 0 || entry.prints > 0 ? this.data.push(entry) : null;
    });
  }

  prepareDataByEnvironment(): void {
    const data = this.prepareData();
    this.data = data;
  }

  prepareData(): DataEntry[] {
    const data: DataEntry[] = [];
    const days = moment(this.inputData.meta.report.end).diff(
      this.inputData.meta.report.start,
      "days"
    );

    this.lineItems.forEach((lineItemId) => {
      const filteredData = this.inputData.data.filter(
        (d) => d.lineItemId === lineItemId
      );
      const lineItem: LineItem | undefined = (this.inputData
        .campaign as Campaign).lineItems.find((l) => l.id === lineItemId);
      const adUnitId = lineItem?.adUnitId;
      const definitions = lineItem?.definitionValueIds;

      const entry: DataEntry = {
        lineItemId: lineItemId,
        adUnitId: adUnitId,
        definitions: definitions,
        environment: null,
        country: null,
        days: days,
        prints: 0,
        clicks: 0,
      };

      filteredData.forEach((d) => {
        entry.prints += d.prints;
        entry.clicks += d.clicks;
      });
      entry.prints > 0 || entry.clicks > 0 ? data.push(entry) : null;
    });

    return data;
  }

  getAdUnit(id: string): string {
    const adUnit = this.inputData.adUnits?.find((e) => e.id === id);
    return adUnit ? adUnit?.name : "";
  }

  getDefinition(definitions: string[], type: string): string {
    const definition = this.inputData.definitions?.find(
      (def) => def.value === type
    );
    const defValue = definition?.values.find((v) =>
      definitions.includes(v.id as string)
    );
    return defValue ? defValue.name : "";
  }

  buildHeaders(): void {
    switch (this.groupType) {
      case "by_position":
        this.headers = [
          {
            text: this.$t("reports.campaign.position").toString(),
            sortable: false,
            value: "adUnitId",
          },
          {
            text: this.$t("reports.campaign.days").toString(),
            sortable: false,
            value: "days",
          },
          {
            text: "Prints",
            sortable: false,
            value: "prints",
          },
          {
            text: "Clicks",
            sortable: false,
            value: "clicks",
          },
        ];
        break;
      case "by_environment":
        this.headers = [
          {
            text: this.$t("reports.campaign.position").toString(),
            sortable: false,
            value: "adUnitId",
          },
          {
            text: this.$t("reports.campaign.environment").toString(),
            sortable: false,
            value: "environment",
          },
          {
            text: this.$t("reports.campaign.location").toString(),
            sortable: false,
            value: "country",
          },
          {
            text: this.$t("reports.campaign.days").toString(),
            sortable: false,
            value: "days",
          },
          {
            text: "Prints",
            sortable: false,
            value: "prints",
          },
          {
            text: "Clicks",
            sortable: false,
            value: "clicks",
          },
        ];
        break;
    }
  }

  get getTotals(): { clicks: number; prints: number } {
    let clicks = 0;
    let prints = 0;
    this.data.forEach((item) => {
      clicks += item.clicks;
      prints += item.prints;
    });

    return { clicks: clicks, prints: prints };
  }

  get colSpan(): number {
    return this.groupType === "by_environment" ? 3 : 1;
  }
}
